<template>
    <router-view :key="$route.fullPath"/>
</template>

<script>
	import store from '../store';

	const beforeRouter = async (to, from, next) => {
		await store.dispatch('fetchPortalSettingsAsync');

		store.dispatch('fetchProjectsAsync')
			.then(() => {
				if (to.params.projectSchema) {
					const index = store.state.projects.findIndex(x => x.schema === to.params.projectSchema);
					if (index < 0)
						return new Error('Project not found.');
					else
						return to.params.projectSchema;
				} else return store.state.projects[0].schema;
			})
			.then((currentProjectSchema) => {
				if (to.params.projectSchema || to.name === 'private' || to.name === 'page_in_development') {
					next();
				} else
					next({name: 'map', params: {projectSchema: currentProjectSchema}});
			})
			.catch((e) => {
				next({name: 'error', params: {errorMessage: e.message}});
			});
	};
	export default {
		async beforeRouteEnter(to, from, next) {
			await beforeRouter(to, from, next);
		},
		async beforeRouteUpdate(to, from, next) {
			if (to.name === 'home')
				await beforeRouter(to, from, next);
			else
				next();
		},
	}
</script>
<style>
    #app {
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
